import sleep from '@/utils/sleep'
import config from '@/config/config'

// web auth専用
export default function retry(promiseFunc, max) {
  let count = 0

  function retryFunc() {
    count++
    return promiseFunc()
      .then((res) => {
        if (count >= max) return res
        switch (res.status) {
          case 200:
            return res
          case 202:
            return sleep(1000).then(() => retryFunc())
          default:
            return res
        }
      })
      .catch((err) => {
        // くら側の皿価格設定取得に失敗した場合リトライする
        if (count >= config.authKuraPriceInfoErrorRetryCount) throw err
        if (
          err.response.status === 403 &&
          err.response.data.message.includes(config.authKuraPriceInfoErrorCode)
        ) {
          return sleep(1000).then(() => retryFunc())
        }
        throw err
      })
  }
  return retryFunc()
}
